import { Navigate } from "react-router-dom";
import { getUserFromToken } from "../utils/auth";

function ProtectedRoute({ children, role }) {
  const user = getUserFromToken();

  // ❌ Not logged in
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // ❌ Logged in but wrong role
  if (role && user.role !== role) {
    return <Navigate to="/" replace />;
  }
  

  // ✅ Allowed
  return children;
}

export default ProtectedRoute;